import { toast } from 'sonner';
import i18next from 'i18next';

import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class BusinessCalendarIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async loadAll() {
        try {
            const [hoursRes, holidaysRes] = await Promise.all([
                this.service.getHours(),
                this.service.listHolidays(),
            ]);
            return {
                success: true,
                hours: hoursRes.data ?? null,
                holidays: holidaysRes.data || [],
            };
        } catch (error) {
            const msg = getIntegrationErrorMessage(error);
            toast.error(msg);
            return { success: false, error: msg, hours: null, holidays: [] };
        }
    }

    async saveHours(body) {
        try {
            const r = await this.service.upsertHours(body);
            toast.success(
                i18next.t('businessCalendar:messages.hoursSaved', { defaultValue: 'Business hours saved' }),
            );
            return { success: true, data: r.data };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false, error: getIntegrationErrorMessage(error) };
        }
    }

    async addHoliday(body) {
        try {
            const r = await this.service.createHoliday(body);
            toast.success(
                i18next.t('businessCalendar:messages.holidayAdded', { defaultValue: 'Holiday added' }),
            );
            return { success: true, data: r.data };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false, error: getIntegrationErrorMessage(error) };
        }
    }

    async previewDeadline(body) {
        try {
            const r = await this.service.previewDeadline(body);
            return { success: true, data: r.data };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false, error: getIntegrationErrorMessage(error) };
        }
    }

    async removeHoliday(id) {
        try {
            const r = await this.service.deleteHoliday(id);
            toast.success(
                i18next.t('businessCalendar:messages.holidayDeleted', { defaultValue: 'Holiday deleted' }),
            );
            return { success: true, data: r.data };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false, error: getIntegrationErrorMessage(error) };
        }
    }
}
